function DeleteOrDeactivateUserCtrl(
  Authentication,
  Restangular,
  user,
  users,
  mode,
  $uibModalInstance
) {
  'ngInject';

  const modalController = this;
  modalController.user = user;
  modalController.userNames = user.fullname;
  modalController.users = users;

  modalController.mode = mode;

  modalController.shifts = 'delete';
  modalController.to = undefined;
  modalController.tasks = 'delete';
  modalController.tasksTo = undefined;
  modalController.oldTasksUsed = Authentication.user.org.oldTasksUsed;

  modalController.submit = function submit() {
    const params = {
      shifts: modalController.shifts,
      to: modalController.to?.length ? modalController.to[0].id : undefined,
      tasks: modalController.tasks,
      tasksTo: modalController.tasksTo?.length ? modalController.tasksTo[0].id : undefined,
    };

    const data =
      mode === 'delete' ? [{ id: user.id, deleted: true }] : [{ id: user.id, active: false }];
    const promise = Restangular.all('users').customPUT(data, null, params);

    promise
      .then(() => {
        $uibModalInstance.close(promise);
      })
      .catch((e) => {
        console.log(e);
      });

    return promise;
  };
}

export default DeleteOrDeactivateUserCtrl;
